// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YoutubePlayer__placeholder--lDgYe {
    width: 100%;
    padding: 8px;
    border-radius: 6px;
    background-color: #1E2028;
}

    @media screen and (min-width: 1024px) {.YoutubePlayer__placeholder--lDgYe {
        padding: 16px
}
    }

.YoutubePlayer__placeholderWrapper--dwj8J {
    padding-top: 56.25%;
    position: relative;
    cursor: pointer;
}

.YoutubePlayer__placeholderImage--cd1IS {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    position: absolute;
    top: 0;
    left: 0;
}

.YoutubePlayer__youtubeImage--TVpiV {
    width: 72px;
    height: 72px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@media screen and (min-width: 1024px) {

.YoutubePlayer__wrapper--fP4fY {
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background-color: rgba(9, 10, 14, 0.9);
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10
}
    }

.YoutubePlayer__playerWrapper--sDote {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
}

@media screen and (min-width: 1024px) {

.YoutubePlayer__playerWrapper--sDote {
        width: 840px;
        height: 472px;
        padding-top: 0
}
    }

.YoutubePlayer__player--zzG7V {
    position: absolute;
    top: 0;
    left: 0;
}

@media screen and (max-width: 1023px) {

.YoutubePlayer__iconClose--PN0dD {
        display: none;
}
    }

.YoutubePlayer__iconClose--PN0dD {

    padding: 8px;
    border-radius: 6px;
    background-color: #1E2028;
    cursor: pointer;
    position: absolute;
    top: -44px;
    right: -44px;
    z-index: 1;
    color: var(--dark-fourth-new-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui-v2/components/YoutubePlayer/YoutubePlayer.css","<no source>"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAK7B;;IAHI,uCANJ;QAOQ;AAER;IADI;;AAGJ;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAGI;;AADJ;QAEQ,eAAe;QACf,QAAQ;QACR,SAAS;QACT,UAAU;QACV,WAAW;QACX,sCAAsC;QACtC,YAAY;QACZ,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB;AAER;IADI;;AAGJ;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AAOtB;;AALI;;AALJ;QAMQ,YAAY;QACZ,aAAa;QACb;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAGI;;AADJ;QAEQ,aAAa;AAYrB;IAXI;;AC1EJ;;ID4EI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,mCAAA;AAYJ","sourcesContent":[".placeholder {\n    width: 100%;\n    padding: 8px;\n    border-radius: 6px;\n    background-color: #1E2028;\n\n    @media (--large) {\n        padding: 16px;\n    }\n}\n\n.placeholderWrapper {\n    padding-top: 56.25%;\n    position: relative;\n    cursor: pointer;\n}\n\n.placeholderImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.youtubeImage {\n    width: 72px;\n    height: 72px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.wrapper {\n    @media (--large) {\n        position: fixed;\n        top: 0px;\n        left: 0px;\n        right: 0px;\n        bottom: 0px;\n        background-color: rgba(9, 10, 14, 0.9);\n        width: 100vw;\n        height: 100vh;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 10;\n    }\n}\n\n.playerWrapper {\n    width: 100%;\n    padding-top: 56.25%;\n    position: relative;\n\n    @media (--large) {\n        width: 840px;\n        height: 472px;\n        padding-top: 0;\n    }\n}\n\n.player {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.iconClose {\n    @media (--mobile) {\n        display: none;\n    }\n\n    padding: 8px;\n    border-radius: 6px;\n    background-color: #1E2028;\n    cursor: pointer;\n    position: absolute;\n    top: -44px;\n    right: -44px;\n    z-index: 1;\n    color: var(--dark-fourth-new-color);\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": `YoutubePlayer__placeholder--lDgYe`,
	"placeholderWrapper": `YoutubePlayer__placeholderWrapper--dwj8J`,
	"placeholderImage": `YoutubePlayer__placeholderImage--cd1IS`,
	"youtubeImage": `YoutubePlayer__youtubeImage--TVpiV`,
	"wrapper": `YoutubePlayer__wrapper--fP4fY`,
	"playerWrapper": `YoutubePlayer__playerWrapper--sDote`,
	"player": `YoutubePlayer__player--zzG7V`,
	"iconClose": `YoutubePlayer__iconClose--PN0dD`
};
export default ___CSS_LOADER_EXPORT___;
